'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from '@/i18n/navigation';
import { Globe } from '@phosphor-icons/react';
import { useLanguageConfig } from '@/lib/brand/use-language-config';
export default function LocaleSwitcher(t0) {
  const $ = _c(17);
  const {
    locale
  } = t0;
  const pathname = usePathname();
  const languages = useLanguageConfig();
  const otherLocale = locale === "ar" ? "en" : "ar";
  let t1;
  if ($[0] !== languages.primary || $[1] !== languages.secondary || $[2] !== locale) {
    t1 = locale === "ar" ? languages.primary.code.toUpperCase() : languages.secondary.code.toUpperCase();
    $[0] = languages.primary;
    $[1] = languages.secondary;
    $[2] = locale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentLabel = t1;
  const switchTitle = locale === "ar" ? languages.secondary.name : languages.primary.name;
  let t2;
  if ($[4] !== otherLocale || $[5] !== pathname) {
    t2 = function handleSwitch() {
      window.location.href = `/${otherLocale}${pathname}`;
    };
    $[4] = otherLocale;
    $[5] = pathname;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleSwitch = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Globe size={18} aria-hidden="true" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== currentLabel) {
    t4 = <span className="text-[11px] font-semibold">{currentLabel}</span>;
    $[8] = currentLabel;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== switchTitle) {
    t5 = <span className="sr-only">— {switchTitle}</span>;
    $[10] = switchTitle;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleSwitch || $[13] !== switchTitle || $[14] !== t4 || $[15] !== t5) {
    t6 = <button onClick={handleSwitch} title={switchTitle} className="inline-flex items-center justify-center gap-1 h-10 px-2.5 rounded-lg text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-subtle/50 transition-colors">{t3}{t4}{t5}</button>;
    $[12] = handleSwitch;
    $[13] = switchTitle;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}